import { api } from '../lib/api';
import type { Bot, BotRun } from '../types';

function parseBot(data: any): Bot {
  return {
    id: data.id,
    name: data.name,
    description: data.description ?? '',
    instructions: data.instructions,
    seq: data.seq ?? 0,
    triggerType: data.triggerType ?? 'manual',
    schedule: data.schedule ?? null,
    createdBy: data.createdBy,
    createdAt: new Date(data.createdAt),
    updatedAt: new Date(data.updatedAt),
    lastRunAt: data.lastRunAt ? new Date(data.lastRunAt) : null,
  };
}

function parseBotRun(data: any): BotRun {
  return {
    id: data.id,
    botId: data.botId,
    status: data.status,
    result: data.result,
    triggeredBy: data.triggeredBy,
    createdAt: new Date(data.createdAt),
    completedAt: data.completedAt ? new Date(data.completedAt) : null,
  };
}

export async function listBots(): Promise<Bot[]> {
  const results = await api<any[]>('/api/bots');
  return results.map(parseBot);
}

export async function createBot(data: {
  name: string;
  description?: string;
  instructions: string;
  seq?: number;
  triggerType?: string;
  schedule?: string;
}): Promise<string> {
  const res = await api<{ id: string }>('/api/bots', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return res.id;
}

export async function updateBot(
  id: string,
  data: {
    name?: string;
    description?: string;
    instructions?: string;
    seq?: number;
    triggerType?: string;
    schedule?: string;
  },
): Promise<void> {
  await api(`/api/bots/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export async function deleteBot(id: string): Promise<void> {
  await api(`/api/bots/${id}`, { method: 'DELETE' });
}

export async function runBot(id: string): Promise<{ runId: string; status: string; result: string }> {
  return api(`/api/bots/${id}/run`, { method: 'POST' });
}

export async function getBotRuns(id: string): Promise<BotRun[]> {
  const results = await api<any[]>(`/api/bots/${id}/runs`);
  return results.map(parseBotRun);
}
